<template>
    <div>
        <design-2021-apprentice-pie-chart-component
            :series="series"
            :options="chartOptions"
            :styles="customStyles">
        </design-2021-apprentice-pie-chart-component>
    </div>
</template>

<script>
export default {
    name: "design-2021-statistics-index-editors-component",
    props: [
        'editorsIn'
    ],
    data(){
        return{
            series: this.editorsIn,
            chartOptions: {
                labels: ['Microsoft Office Online', 'Google Docs', 'Office 365', 'Only Office'],
                chart: {
                    type: 'donut',
                    height: 350,
                },
                colors: ['#17a2b8', '#007bff', '#ffb548', '#0acf97'],
            }
        }
    },
    computed: {
        customStyles() {
            return {
                height: `${this.height}px`,
                width: '100%',
                position: 'relative',
            }
        },
    },
}
</script>

<style scoped>

</style>
